import { FloatingFormItem } from '@/components/_common';
import { BankAccount } from '@/core/domain/enterprise/BankAccounts/BankAccounts.types';
import { TitleAcceptance } from '@/core/domain/enterprise/BankAccountsSettings/BankAccountsSettings.types';
import { bankAccountsSettingsTitleDocSpecies } from '@/core/domain/enterprise/BankAccountsSettings/bankAccountsSettingsTitleDocSpecies';
import { bankConfig } from '@/core/domain/financial/Boletos/Boletos.dictionary';
import { Col, Select } from 'antd';

interface Props {
  bankAccount?: BankAccount;
}

export default function ConfigBankSlipBasicFields({ bankAccount }: Props) {
  const bankMapFields = bankAccount ? bankConfig[bankAccount?.bank.code] : null;

  const bankAccountsSettingsTitleDocSpeciesFilter = !!bankMapFields?.fields
    .titleDocumentSpecies?.options?.length
    ? bankAccountsSettingsTitleDocSpecies
        .filter((item) =>
          bankMapFields?.fields.titleDocumentSpecies?.options?.includes(
            item.code,
          ),
        )
        .map((doc) => ({
          value: doc.code,
          label: `${doc.code} - ${doc.description}`,
        }))
    : bankAccountsSettingsTitleDocSpecies.map((doc) => ({
        value: doc.code,
        label: `${doc.code} - ${doc.description}`,
      }));

  return (
    <>
      <Col span={24} md={12} lg={6} xxl={4}>
        <FloatingFormItem
          label="Documento de espécies"
          name={['general', 'titleDocumentSpecies']}
        >
          <Select
            allowClear
            style={{ width: '100%' }}
            options={bankAccountsSettingsTitleDocSpeciesFilter}
          />
        </FloatingFormItem>
      </Col>

      <Col span={24} md={12} lg={6} xxl={4}>
        <FloatingFormItem
          label="Titulo Aceite"
          name={['general', 'titleAcceptance']}
          initialValue={bankMapFields?.fields.titleAcceptance?.initialValue}
        >
          <Select
            allowClear
            style={{ width: '100%' }}
            options={[
              {
                value: TitleAcceptance.accepted,
                label: 'Sim',
              },
              {
                value: TitleAcceptance.notAccepted,
                label: 'Não',
              },
            ]}
          />
        </FloatingFormItem>
      </Col>
    </>
  );
}
